import Vue from 'vue'
import Router from 'vue-router'
import formflow from '../views/formflow/index.vue'
import formflowWorkbench from '../views/formflow/workbench.vue'
import formflowWorkIndex from '../views/formflow/workIndex.vue'
import fDictionary from '../views/formflow/ff_dictionary/index.vue'
import fAuth from '../views/formflow/ff_auth/index.vue'
import fInterface from '../views/formflow/ff_interface/index.vue'
import fAcl from '../views/formflow/ff_acl/index.vue'
import formflowWorklist from '../views/formflow/worklist/index.vue'
import formflowAppflow from '../views/formflow/appflow/index.vue'
import management from '../views/formflow/appflow/manage/management.vue'
import design from '../views/formflow/appflow/design/index.vue'
import print from '../views/formflow/ff_print/index.vue'
import instanceManage from '../views/formflow/Instance_manage/index.vue'
import historyData from '../views/formflow/history_manage/index.vue'
import urgedManage from '../views/formflow/urged_manage/index.vue'
import Stamp from '../views/formflow/stamp_manage/index.vue'
import TTC from '../views/formflow/ttc_manage/index.vue'
import Recycle from '../views/formflow/recycle_manage/index.vue'
import notfound from '@/views/404'

// 不要使用懒加载()=>import()引入组件
Vue.use(Router)
const constantRouterMap = [
  {
    path: '/',
    name: 'formflow',
    component: formflow,
    meta: { title: '流程管理' }
  },
  {
    path: '/workbench',
    name: 'formflowWorkIndex',
    component: formflowWorkIndex,
    redirect: '/workbench',
    children: [
      {
        path: '/workbench',
        name: 'formflowWorkbench',
        component: formflowWorkbench,
        meta: { title: '流程管理-工作台' }
      },
      {
        path: '/workbench/dictionary/:id',
        name: 'fDictionary',
        component: fDictionary,
        meta: { title: '流程管理-字典管理' }
      },
      {
        path: '/workbench/auth/:id',
        name: 'fAuth',
        component: fAuth,
        meta: { title: '流程管理-授权管理' }
      },
      {
        path: '/workbench/interface/:id',
        name: 'fInterface',
        component: fInterface,
        meta: { title: '流程管理-接口管理' }
      },
      {
        path: '/workbench/acl/:fid',
        name: 'fAcl',
        component: fAcl,
        meta: { title: '流程管理-访问授权' }
      },
      {
        path: '/workbench/print/:fid',
        name: 'print',
        component: print,
        meta: { title: '流程管理-打印设计' }
      }
    ]
  },
  {
    path: '/instanceManage',
    name: 'instanceManage',
    component: instanceManage,
    meta: { title: '流程管理-实例管理' }
  },
  {
    path: '/historyData',
    name: 'historyData',
    component: historyData,
    meta: { title: '流程管理-历史数据' }
  },
  {
    path: '/stamp',
    name: 'stamp',
    component: Stamp,
    meta: { title: '流程管理-签章管理' }
  },
  {
    path: '/recycle',
    name: 'recycle',
    component: Recycle,
    meta: { title: '流程管理-回收站管理' }
  },
  {
    path: '/ttc',
    name: 'ttc',
    component: TTC,
    meta: { title: '流程管理-事务管理' }
  },
  {
    path: '/urgedManage',
    name: 'urgedManage',
    component: urgedManage,
    meta: { title: '流程管理-督办' }
  },
  {
    path: '/worklist',
    name: 'formflowWorklist',
    component: formflowWorklist,
    meta: { title: '流程管理-事务中心' }
  },
  {
    // path: '/appflow/:fid',
    // name: 'formflowAppflow',
    // redirect: '/appflow/:fid/management',
    path: '/workbench/:fid',
    name: 'formflowAppflow',
    redirect: '/workbench/:fid/management',
    component: formflowAppflow,
    children: [{
      path: 'management',
      name: 'management',
      component: management,
      meta: { title: '流程管理-应用管理' }
    }, {
      path: 'design',
      name: 'design',
      component: design,
      meta: { title: '流程管理-应用管理' }
    }]
  },
  { path: '*', name: '404', component: notfound, meta: { title: '流程管理-404' } }

]

export default new Router({
  mode: 'history', // 后端支持可开
  base: `/${process.env.VUE_APP_BASE_URL}/`,
  routes: constantRouterMap
})
